import { Input } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import { Form } from 'formik';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

export const InputSearch = styled(Input)`
  border-radius: ${tokens.radii.m};
  height: 46px;
`;

export const FormSearch = styled(Form)<SpaceProps & LayoutProps>`
  display: flex;
  align-items: center;

  ${space};
  ${layout};
`;
